var map = {
	"./demos/basic/index.ts": 93782,
	"./demos/directory/index.ts": 68284,
	"./demos/drag/index.ts": 52472,
	"./demos/files/index.ts": 7197,
	"./demos/gallery/index.ts": 33407,
	"./demos/manually/index.ts": 31307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 113;